import React from "react";
import MarketingArt from "../MarketingArt.jsx";

// Horizontal step card: a compact square thumbnail, then the step label, title
// and description.
//
// The thumbnail sits exactly where the icon medallion used to, at roughly the
// same visual weight. That is deliberate — the image IS the icon here. An
// earlier version ran the photo full-width at 16:10 with the icon medallion
// overlaid in its corner, which gave each step two competing marks and made the
// row far taller than the copy needed.
//
// `image` is optional. Without it — or before scripts/gen-images.mjs has run —
// the card falls back to the icon medallion, because MarketingArt renders its
// fallback on a 404. So this stays correct either way.
//
// `perRow` is how many of these the parent grid shows on lg. It only decides
// where the connector rule stops: a connector is drawn to the next step EXCEPT
// on the last card of each row and the very last overall, otherwise the rule
// dangles off the right edge where the grid wraps. If the parent changes its lg
// column count, change this to match.
const TimelineStep = ({ icon: Icon, image, index, total, title, description, perRow = 3 }) => {
  const isRowEnd = (index + 1) % perRow === 0;
  const isLast = index === total - 1;
  const showConnector = !isRowEnd && !isLast;

  const medallion = (
    <div className="w-full h-full rounded-[14px] landing-aurora text-white grid place-items-center shadow-[var(--land-shadow)]">
      <Icon size={22} />
    </div>
  );

  return (
    <div className="relative flex flex-col h-full">
      {showConnector && (
        <div
          className="hidden lg:block absolute top-[66px] left-[148px] right-[-24px] h-px bg-[var(--land-line)]"
          aria-hidden="true"
        />
      )}

      <div className="relative z-10 w-[132px] h-[132px] flex-none rounded-[16px] overflow-hidden border border-[var(--land-line)] bg-[var(--land-panel-2)]">
        {image ? (
          <MarketingArt src={image} className="w-full h-full object-cover block" fallback={medallion} />
        ) : (
          medallion
        )}
      </div>

      <div className="mt-4">
        <div className="text-[11px] font-bold text-[var(--land-primary)] uppercase tracking-[.12em]">
          Step {index + 1}
        </div>
        <h3 className="font-disp text-[18px] font-bold mt-1 tracking-[-.01em] text-[var(--land-ink)]">{title}</h3>
        <p className="text-[var(--land-muted)] text-[15px] mt-1.5 leading-[1.6]">{description}</p>
      </div>
    </div>
  );
};

export default TimelineStep;
